<template>
  <div class="bui-entity-listing-page player-subscription-editor-redesign">
    <content-with-loading-skeleton
      :isLoading="isLoading"
      loadingMessage="Loading Player Subscription Data..."
      :isWithMessage="true"
    >
      <template #loaded>
        <div class="player-subscription-editor-redesign__inner">
          <TopBar />

          <InfoCard>
            <template #title>
              <h2 class="info-card__title-text">Target Players Filters</h2>
            </template>
            <PlayersFilters v-model="data.filters" />
          </InfoCard>

          <InfoCard>
            <template #title>
              <h2 class="info-card__title-text">Subscription Bindings</h2>
            </template>
            <!-- Debugging Helper -->
            <!-- <pre class="overflow-y-scroll h-60">data.bindings from Player Subscription Editor View: {{ data.bindings }}</pre> -->
            <SubscriptionBindings v-model="data.bindings" />
          </InfoCard>

          <!-- Sticky footer -->
          <footer class="editor-footer">
            <div class="editor-footer__inner">
              <ExitButton
                v-bind="{hasUnsavedChanges, unsetHasUnsavedChanges}"
                @exit="onExit"
                @saveAndExit="onSaveAndExit"
              />
              <SaveSubscriptionButton ref="saveSubscriptionButtonRef" @save="onSave" />
            </div>
          </footer>
        </div>
      </template>
    </content-with-loading-skeleton>
  </div>
</template>


<script setup lang="ts">
import TopBar from './TopBar/TopBar.vue';
import {onBeforeMount}  from 'vue'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import SaveSubscriptionButton from './SaveSubscriptionButton/SaveSubscriptionButton.vue';
import ExitButton from '@/components/Dialog/ButtonsWithDialog/ExitButton/ExitButton.vue';
import InfoCard from '@/components/bui/molecules/InfoCard/InfoCard.vue';
import sharedRefs from './sharedRefs';
import router from '@/router';
import PlayersFilters from './PlayersFilters/PlayersFilters.vue';
import SubscriptionBindings from './SubscriptionBindings/SubscriptionBindings.vue';
import { updateReactiveObject } from '@/helpers/utils/utils';
import { usePlayerSubscription } from './composables/playerSubscription';
const { data } = usePlayerSubscription();


const { loadPlayerSubscription, initializeHasUnsavedChangesWatcher, hasUnsavedChanges, unsetHasUnsavedChanges, isLoading } = usePlayerSubscription();
initializeHasUnsavedChangesWatcher();

const route = useRoute()

const currentSubscriptionId = route.params.id as string;
const { saveSubscriptionButtonRef } = sharedRefs;

function onExit() {
  router.push({ path: '/player-subscriptions' })
}

async function onSave(savedData: any) {
  // console.log({ savedData, data }); // Debugging Helper
  updateReactiveObject(data, savedData);
}

async function onSaveAndExit() {
  await saveSubscriptionButtonRef.value.savePlayerSubscription();
  router.push({ path: '/player-subscriptions' })
}

onBeforeMount(async () => {
  await loadPlayerSubscription(currentSubscriptionId);
});

onBeforeRouteUpdate(async (newRoute) => {
  if(newRoute.name === "player-subscription-editor") {
    const newPlaylerSubscriptionId = newRoute.params.id;
    await loadPlayerSubscription(newPlaylerSubscriptionId);
  }
})
</script>



<style lang="scss" scoped>
@import '@/assets/styles/bui-editor-template';

/* Outer wrapper: paints the BUI page surface edge-to-edge (see the note in
   PlayerEditorView — `.bui-entity-listing-page` is wired in PageLayout.vue). */
.player-subscription-editor-redesign {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  background: var(--bui-page-fill, #ff007b);
  color: var(--bui-page-head, #fffcfd);
  padding: var(--bui-page-pad-y, 32px) var(--bui-page-pad-x, 48px) 5rem;
  box-sizing: border-box;

  @media (max-width: 1100px) {
    padding-left: 24px;
    padding-right: 24px;
  }
}

.player-subscription-editor-redesign__inner {
  display: flex;
  flex-direction: column;
  gap: var(--bui-page-section-gap, 24px);
  width: 100%;
  flex: 1 1 auto;
  min-width: 0;
}
</style>
